import checkAccess from 'utils/roles/checkAccess';

export const routerPath = {
  root: '/Colors',
};

export const getColumns = ({ editItem, deleteItem }) => {
  const initialArr = [{ id: 'name', label: 'Color', align: 'left' }];

  if (checkAccess([0, 1, 2])) {
    return [
      ...initialArr,
      {
        id: 'more-menu',
        type: 'menu',
        items: [
          {
            id: 1,
            name: 'Delete',
            action: (id) => deleteItem(id),
            icon: 'eva:trash-2-outline',
            sx: { color: 'error.main' },
          },
          { id: 2, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
        ],
        disableSort: true,
      },
    ];
  }
  return initialArr;
};

export const getFilters = ({ searchBy }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Color name',
    action: searchBy.change,
  },
];
